import styled from "styled-components/macro";

export const StyledContainer = styled.div`
  position: fixed;
  width: 100%;
  height: 100vh;
  z-index: 20000;
  text-align: center;
  overflow-x: scroll;

  .inner {
    margin: auto;
    padding: 0 3em;
    text-align: center;
    max-width: 650px;
  }

  .page-title {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: flex-start;
    max-width: 90vw;
    margin-bottom: 12px;
    margin-left: 35px;
    margin-top: 12px;
    gap: 15px;
    position: sticky;
    left: 20px;
    cursor: pointer;
    h1 {
      width: 500px;
      flex-grow: 3;
    }

    small {
      width: 300px;
      font-size: 12px;
      color: var(--grey-1);
    }

    .quota-cta {
      max-width: 1200px;
      margin: 0 auto;
      padding: 0 30px;
      flex-grow: 3;

      & > div {
        margin-bottom: 0;
      }
    }
  }

  .close {
    position: fixed;
    top: 26px;
    right: 20px;
    z-index: 30000;
    svg {
      stroke: var(--grey-0);
      fill: var(--grey-0);
    }
  }

  h2 {
    /* margin-left: 35px; */
  }

  // old story engine styles

  .container {
    margin: auto;
    text-align: center;

    .section {
      text-align: center;
      margin-top: 1em;
      /* padding-right: 35px; */
      margin-bottom: 35px;
      width: calc(100%);
    }
  }

  h1 {
    max-width: none;
    text-align: left;
    margin-left: 0;
    margin-bottom: 0;
    color: var(--grey-0);
  }

  h1,
  h2,
  h3 {
    color: var(--grey-0);
    line-height: 1.5em;
  }

  h3 {
    margin-bottom: 1em;
  }

  .header {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    margin-bottom: 20px;
    gap: 20px;
    justify-content: flex-end;
    h1 {
      display: flex;
      align-items: center;
      gap: 8px;
    }

    .right-side {
      display: flex;
      gap: 12px;
      position: sticky;
      right: 60px;
      margin-top: 8px;
      margin-bottom: 0px;
      z-index: 30000;

      button {
        margin-top: 0 !important;
        padding: 5px 15px !important;
        border-radius: 8px !important;
      }
      .select {
        width: 150px;
        position: relative;
        z-index: 30000;
      }
    }
    h1 {
      margin-bottom: 0 !important;
    }
  }

  button {
    padding: 5px 15px !important;
    border-radius: 20px !important;

    &:disabled {
      background: var(--grey-2) !important;
    }
  }

  .delete-cta {
    background: transparent !important;
    margin-top: 0px !important;
    margin-right: 12px;
    display: flex;
    align-items: center;
    padding: 4px 6px !important;
    border-radius: 8px !important;
    transition: background 200ms;
    position: relative;
    z-index: 30000;
    &:before {
      opacity: 0;
      transition: opacity 0.2s linear;
      transition-delay: 0.2s;
      position: absolute;
      content: "";
    }
    &:hover {
      background: var(--container-color) !important;
      &:before {
        content: "Delete this Chapter";
        text-transform: none;
        position: absolute;
        opacity: 1;
        left: 50%;
        transform: translate(-50%, 10px);
        line-height: 20px;
        height: 20px;
        font-weight: 500;
        top: 33px;
        padding: 3px 8px;
        background-color: var(--grey-0);
        color: var(--context-menu-text);
        border-radius: 6px;
        font-size: 12px;
        white-space: nowrap;
        z-index: 31000;
      }
    }
    svg {
      width: 22px;
      path {
        fill: var(--grey-1);
      }
      /* margin-right: 8px; */
      /* margin-left: -4px; */
    }
  }

  textarea {
    color: var(--grey-0);
    background: var(--document-background);
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    width: 100%;
    min-width: 600px;
    height: 450px;
    font-size: 18px;
    padding: 1em;
    min-height: 300px;
    margin-bottom: 1em;
    line-height: 1.4em;
    font-family: "Inter";

    &.wide {
      width: 800px;
    }

    &.medium {
      min-height: 200px;
    }

    &.short {
      min-height: 116px;
    }
  }

  textarea.genre {
    height: 100px;
    min-height: 0;
  }

  .scenes {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: flex-start;
    gap: 30px;
    min-width: 700px;
    position: relative;
    z-index: 10000;

    .header {
      /* height: 3px; */

      h3 {
        position: relative;
        top: 10px;
      }
    }
  }

  .draft-header {
    position: sticky;
    top: 0px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0px;
    background: var(--menu-color);
    z-index: 20000;
    .left-side {
      display: flex;
      align-items: center;
      .help {
        line-height: 24px;
        border-radius: 25px;
        height: 25px;
        width: 25px;
        position: relative;
        color: var(--grey-0);
        display: block;
        padding: 0;
        font-weight: bold;
        font-size: 17px;
        text-align: center;
        background: var(--menu-color-active);
        margin-left: 8px;
      }
    }
    h2 {
      font-weight: 500;
      font-size: 20px !important;
      margin-left: 12px;
      margin-bottom: 0px !important;
    }
  }

  .toast {
    position: fixed;
    bottom: 20px;
    right: 50%;
    background: var(--icon-button-fill);
    padding: 10px 15px;
    font-size: 18px;
    font-family: Inter;
    font-weight: 500;
    color: var(--text-highlight);
    border-radius: 5px;
    z-index: 100000000;
    transform: translate(50%, 0);
    animation: fade-in 0.5s ease forwards;
    opacity: 0;
  }

  @keyframes fade-in {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;
